"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceInvader = void 0;
var three_1 = require("three");
var CSS3DRenderer_1 = require("three/examples/jsm/renderers/CSS3DRenderer");
var function_1 = require("../util/function");
var SpaceInvader = /** @class */ (function () {
    function SpaceInvader(base) {
        this.base = base;
        this.offset = 1.7;
        this.pos = new three_1.Vector3(0, 0, -this.offset);
        this.normal = new three_1.Vector3(0, 0, -1);
        this.cNormal = new three_1.Vector3();
        this.cPos = new three_1.Vector3();
        this.m4 = new three_1.Matrix4();
        this.setElement();
    }
    SpaceInvader.prototype.setElement = function () {
        this.element = this.base.domBundle.querySelector('#space-invader');
        this.object = new CSS3DRenderer_1.CSS3DObject(this.element);
        this.object.position.set(0, 0, -this.offset);
        this.object.rotation.y = -Math.PI;
        this.object.scale.set(1 / 160, 1 / 160, 1);
    };
    SpaceInvader.prototype.update = function () {
        (0, function_1.updateOcclude)(this);
    };
    return SpaceInvader;
}());
exports.SpaceInvader = SpaceInvader;
